import React, { useEffect, useState } from "react";
import style from "./chargeWallet.module.scss";
import { withRouter, Link } from "react-router-dom";
import Button from "../../Button/button"
import Tooltip from "../../tooltip/tooltip"
import Input from "../../input/input";
import GradientToast from "../../gradientToast/Toast"
import numberWithCommas from "../../../helpers/actions/numberWithCommas";
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import Toast from "../../Toast/Toast"
import { GetWalletDetails, CreateTransaction, GetUser } from "../../../actions/APIcalls"
import Skeleton from "./skeleton"
import Modal from "../../Modal/Modal";


const ChargeWallet = (props) => {

    const [recommendedPrices, setRecommendedPrices] = useState({
        list: [
            { title: '', price: '1000000', gift: '' },
            { title: '', price: '1500000', gift: '' },
            { title: '', price: '2000000', gift: '+ ۵٪ شارژ هدیه' },
            { title: '', price: '5000000', gift: '+ ۱۰٪ شارژ هدیه' },
        ]
    })
    const [walletDetails, setWalletDetails] = useState({
        amount: 0,
        lastMonthAmount: 0,
        lastMonthPricingCount: 0,
        pricingCount: 0,
        showNationalCodeModal: false,
    })
    const [selectedPrice, setSelectedPrice] = useState([])
    const [desiredPrice, setDesiredPrice] = useState({
        price: props.location && props.location.state && props.location.state.totalPrice ? props.location.state.totalPrice : '',
        error: '',
        paymentLoading: false
    })
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [toast, setToast] = useState('')

    useEffect(async () => {
        await getWalletFunction()
    }, [])


    const getWalletFunction = async () => {
        setHasSkeleton(true)
        let res = await GetWalletDetails({ accountId: props.user.account._id, page: 1, count: 10 })
        if (res && res.data) {
            let tmpWalletDetail = res.data
            setWalletDetails({ ...tmpWalletDetail })
            await setNewRecommendation(res.data)
        }
        setHasSkeleton(false)
    }

    const setNewRecommendation = async (details) => {
        // sent to recommended options
        let tmpRecom = recommendedPrices
        let object = {}
        if (details.lastMonthAmount) {
            object = { title: 'هزینه ماه گذشته', price: parseInt(details.lastMonthAmount / 10) }
            tmpRecom.list.push(object)
        }
        if (details.currentMonthAmount) {
            object = { title: 'هزینه این ماه', price: parseInt(details.currentMonthAmount / 10) }
            tmpRecom.list.push(object)
        }

        setRecommendedPrices({ ...tmpRecom })
    }

    const determineLastMonth = () => {
        let lastMonthIndex = 0
        const persianMonths = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند']
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        let current = new Date().toLocaleDateString('fa-IR', options).split(' ')[1]

        persianMonths.map((el, index) => {
            if (el == current && el !== 'فروردین') {
                lastMonthIndex = index - 1
            }
            if (el == current && el == 'فروردین') {
                lastMonthIndex = 11
            }
        })
        return persianMonths[lastMonthIndex]
    }

    const handelSelectedPrice = (selectedItem, index) => {
        let tmp = []
        let tmpDesired = desiredPrice;
        tmpDesired.price = selectedItem.price
        tmp.push(index)
        setSelectedPrice([...tmp])
        setDesiredPrice({ ...tmpDesired })
    }

    const handleDesiredPrice = (tag, value) => {
        let tmpDesired = desiredPrice;
        tmpDesired.price = toEnglishNumber(value.target.value.toString().replaceAll(",", ""))
        setDesiredPrice({ ...tmpDesired })
    }

    const submitPayment = async () => {
        if (desiredPrice.price == '' || toEnglishNumber(desiredPrice.price.toString()) < 500000) {
            let tmp = desiredPrice
            tmp.error = 'حداقل مبلغ برای شارژ کیف پول ۵۰۰ هزار تومان است.'
            setDesiredPrice({ ...tmp })
        } else {
            let tmp = desiredPrice
            tmp.error = ''
            tmp.paymentLoading = true
            setDesiredPrice({ ...tmp })

            // request to get user
            let res = await GetUser()
            if (res && res.data && res.data.user && res.data.user.nationalCode) {
                // request to server
                requestToBank(toEnglishNumber(tmp.price.toString().replaceAll(",", "")))
            } else {
                // redirect to get national code
                let tmpWallet = walletDetails
                tmpWallet.showNationalCodeModal = true
                setWalletDetails({ ...walletDetails })
            }
        }
    }

    const requestToBank = async (price) => {
        let resBank = await CreateTransaction({ "price": price + '0' }, openToast)

        if (resBank) {
            let tmp = desiredPrice
            tmp.paymentLoading = false
            setDesiredPrice({ ...tmp })

            if (resBank.data) {
                window.location.href = 'https://gateway.zibal.ir/start/' + resBank.data.trackId
            }
        }
    }

    const openToast = (error) => {
        setToast(error)
        let tmp = desiredPrice
        tmp.paymentLoading = false
        setDesiredPrice({ ...tmp })
    }

    const closeModalFunction = () => {
        setToast('')
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <Toast
                    tag='Toast'
                    text={toast}
                    value={toast ? true : false}
                    parentClose={closeModalFunction}
                />
                <Modal
                    tag="nationalCodeModal"
                    title={"تکمیل اطلاعات پروفایل"}
                    value={walletDetails.showNationalCodeModal}
                    parentClose={() => setWalletDetails({ ...walletDetails, showNationalCodeModal: false })}
                >
                    <div className={style.nationalCodeWrapper}>
                        <p className={style.title}>موبیشایی عزیز؛</p>
                        <p className={style.text}>بنابر درخواست اداره مالیات جهت صدور فاکتور رسمی برای تمام مشتریان، لازم است <span>کدملی</span> خود را در قسمت پروفایل موبیشا تکمیل بفرمایید.</p>
                        <p className={style.text}>از همکاری شما سپاسگزاریم.</p>
                        <div className={style.buttonWrapper}>
                            <div className={style.redirect}>
                                <Button
                                    disabled={false}
                                    tag="redirectToProfile"
                                    type="solid"
                                    label="ویرایش پروفایل"
                                    onclick={() => props.history.push('/profile')}
                                />
                            </div>
                            <div className={style.calcel}>
                                <Button
                                    disabled={false}
                                    tag="cancel"
                                    type="noBorder"
                                    label="انصراف"
                                    onclick={() => setWalletDetails({ ...walletDetails, showNationalCodeModal: false })}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                <div className={style.header}>
                    <h1>شارژ کیف پول</h1>
                    <div className={style.buttonsWrapper}>
                        <div className={style.settingButton}>
                            <Link to={'/setting'}>
                                <Button
                                    disabled={false}
                                    tag="setting"
                                    type="noBorder"
                                    label="تنظیمات"
                                    onclick={() => { }}
                                />
                            </Link>
                        </div>
                    </div>
                </div>

                {/* <div className={style.bankWarning}>
                    <span className={style.warningIcon}>h</span>
                    <p>در صورت وجود اختلال در اتصال به درگاه بانکی، لطفا مبلغ شارژ مورد نظر خود را به شماره کارت <b>۱۳۷۹ - ۱۸۰۱ - ۱۴۱۱ - ۶۳۶۲</b> به نام هستی توسلی واریز کرده و فیش آن را به واتس‌آپ یا تلگرام شماره پشتیبانی ۰۹۰۲۲۲۷۸۷۰۶ ارسال فرمایید.</p>
                </div> */}


                <div className={style.chargeStatus}>
                    <div className={style.chargeStatusItem}>
                        <div className={style.iconWrapper}><div className={style.currentWallet}></div></div>
                        <div className={style.statsWrapper}>
                            <p className={style.title}>موجودی کیف پول</p>
                            <p className={style.amount}>{walletDetails.amount ? toPersianNumber(numberWithCommas(parseInt(walletDetails.amount / 10))) : '--'} تومان</p>
                            <p className={style.description}>({walletDetails.pricingCount ? toPersianNumber(numberWithCommas(walletDetails.pricingCount)) : '--'} مرتبه قیمت‌گذاری)</p>
                        </div>
                    </div>

                    <div className={style.chargeStatusItem}>
                        <div className={style.iconWrapper}><div className={style.lastMonthWallet}></div></div>
                        <div className={style.statsWrapper}>
                            <p className={style.title}>هزینه ماه گذشته ({determineLastMonth()} ماه)</p>
                            <p className={style.amount}>{walletDetails.lastMonthAmount ? toPersianNumber(numberWithCommas(parseInt(walletDetails.lastMonthAmount / 10))) : '--'} تومان</p>
                            <p className={style.description}>({walletDetails.lastMonthPricingCount ? toPersianNumber(numberWithCommas(walletDetails.lastMonthPricingCount)) : '--'} مرتبه قیمت‌گذاری)</p>
                        </div>
                    </div>
                </div>

                <p className={style.generalDescription}>مبلغ مورد نظر برای شارژ کیف پول خود را انتخاب کنید.</p>
                <h5 className={style.recommendedPricesHeader}>مبالغ پیشنهادی</h5>
                <div className={style.recommendedPricesWrapper}>
                    {recommendedPrices.list.map((priceItem, index) => {
                        if (priceItem.title) {
                            return (
                                <div
                                    key={index}
                                    className={selectedPrice.includes(index) ? style.recommendedPriceSelected : style.recommendedPrice}
                                    onClick={() => handelSelectedPrice(priceItem, index)}
                                >
                                    {priceItem.title} ({toPersianNumber(numberWithCommas(priceItem.price))} تومان)
                                </div>
                            )
                        } else {
                            return (
                                <div
                                    key={index}
                                    className={selectedPrice.includes(index) ? style.recommendedPriceSelected : style.recommendedPrice}
                                    onClick={() => handelSelectedPrice(priceItem, index)}
                                >
                                    {toPersianNumber(numberWithCommas(priceItem.price))} تومان
                                    {priceItem.gift && <span className={style.gift}>{priceItem.gift}</span>}
                                </div>
                            )
                        }
                    }
                    )}
                </div>

                <div className={style.desiredPriceHeader}>
                    <h5 className={style.desiredPriceTitle}>مبلغ دلخواه</h5>
                    <div className={style.toolTipWrapper}>
                        <Tooltip
                            direction='Left'
                            text='درصورتی که مبلغ دلخواه شما درمیان گزینه‌ها موجود نیست، مبلغ دلخواه خود را وارد کنید.'
                        />
                    </div>
                </div>

                <div className={style.desiredPriceInput}>
                    <Input
                        type="text"
                        disabled={false}
                        withToman={true}
                        placeholder="مبلغ دلخواه"
                        error={desiredPrice.error}
                        tag="desiredPrice"
                        value={desiredPrice.price ? numberWithCommas(desiredPrice.price) : ''}
                        onchange={handleDesiredPrice}
                        onblur={() => { }}
                    />
                </div>

                <div className={style.taxWarning}>
                    <div className={style.icon}>h</div>
                    <p className={style.text}><b> ۱۰ درصد</b> مالیات بر ارزش افزوده به مبلغ فاکتور اضافه می‌‌شود</p>
                    {/* <span>مبلغ نهایی: {calculateUltimatePrice(desiredPrice.price)} تومان</span> */}
                </div>

                <div className={style.buttonWrapper}>
                    <div className={style.buttonItem}>
                        <Button
                            loading={desiredPrice.paymentLoading}
                            disabled={false}
                            tag="confirmPayment"
                            type="solid"
                            label="تایید و پرداخت"
                            onclick={() => submitPayment()}
                        />
                    </div>
                    <Link to={'/wallet'}>
                        <Button
                            disabled={false}
                            tag="back"
                            type="noBorder"
                            label="بازگشت"
                            onclick={() => { }}
                        />
                    </Link>
                </div>
            </div>
        )
    }
}

export default withRouter(ChargeWallet);
